import { createContext, useState, useEffect } from 'react';
import { getUserContexts } from '@/persistence/user_context';

interface Attribute {
  id: string
}

interface UserContextShape {
  ready: boolean
  // setReady: (ready: boolean) => void
  debugMode: boolean
  setDebugMode: (use: boolean) => void
  uaAttr: undefined|Attribute
  setUaAttr: any
  ga4Attr: undefined|Attribute
  setGa4Attr: any
  tagManagerAttr: undefined|Attribute
  setTagManagerAttr: any
  optimizeAttr: undefined|Attribute
  setOptimizeAttr: any
  userId: undefined|Attribute
  setUserId: any
  resetUserContext: () => void
}

// @ts-ignore
export const UserContext = createContext<UserContextShape>()

// @ts-ignore
export const UserContextProvider = ({ children }) => {
  const [ready, setReady] = useState(false)

  const [debugMode, setDebugMode] = useState(false)

  const [ga4Attr, setGa4Attr] = useState<undefined|Attribute>(undefined)
  const [uaAttr, setUaAttr] = useState<undefined|Attribute>(undefined)
  const [tagManagerAttr, setTagManagerAttr] = useState<undefined|Attribute>(undefined)
  const [optimizeAttr, setOptimizeAttr] = useState<undefined|Attribute>(undefined)

  const [userId, setUserId] = useState<undefined|Attribute>(undefined)

  const resetUserContext = () => {
    setDebugMode(false)
    setGa4Attr(undefined)
    setUaAttr(undefined)
    setTagManagerAttr(undefined)
    setOptimizeAttr(undefined)
    setUserId(undefined)
  }

  /*
   * TODO: 사용자가 값을 변경했을 때의 처리가 추가되어야한다.
   */
  useEffect(() => {
    (async () => {
      const { debug_mode, ga4_id, ua_id, tag_manager_id, optimize_id, user_id } = await getUserContexts()

      if (debug_mode) { setDebugMode(debug_mode as boolean) }
      if (ga4_id) { setGa4Attr({ id: ga4_id as string }) }
      if (ua_id) { setUaAttr({ id: ua_id as string }) }
      if (tag_manager_id) { setTagManagerAttr({ id: tag_manager_id as string }) }
      if (optimize_id) { setOptimizeAttr({ id: optimize_id as string }) }
      if (user_id) { setUserId({ id: user_id as string }) }

      setReady(true)
    })()
  }, [])

  return (
    <UserContext.Provider value={{
      ready,
      // setReady,
      debugMode,
      setDebugMode,
      ga4Attr,
      setGa4Attr,
      uaAttr,
      setUaAttr,
      tagManagerAttr,
      setTagManagerAttr,
      optimizeAttr,
      setOptimizeAttr,
      userId,
      setUserId,
      resetUserContext,
    }}>
      { children }
    </UserContext.Provider>
  )
}
